export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/HN-b4031d49b76e49566957a8e421adccb6.png";